// src/widgets/Ticket/index.jsx

// styling
import styles from './styles.module.scss';

// components
import LazyImage from '@components/LazyImage';
import Spring from '@components/Spring';
import Submenu from '@ui/Submenu';

// hooks
import useSubmenu from '@hooks/useSubmenu';
import { useNavigate } from 'react-router-dom';

// assets (fallbacks)

const formatDateParts = (iso) => {
  if (!iso) return { date: '—', time: '—' };
  const d = new Date(iso);
  const date = new Intl.DateTimeFormat('de-AT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d); // DD.MM.YYYY
  const time = new Intl.DateTimeFormat('de-AT', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
  return { date, time };
};

const pick = (obj, snake, camel) => obj?.[snake] ?? obj?.[camel];

const Ticket = ({ match, loading }) => {
  const navigate = useNavigate();
  const { anchorEl, open, handleClick, handleClose } = useSubmenu();

  // tolerate snake_case or camelCase from API
  const home = pick(match, 'home_blanket', 'homeBlanket') || {};
  const away = pick(match, 'away_blanket', 'awayBlanket') || {};
  const details = pick(match, 'details', 'details') || {};
  const status = match?.status ?? '—';
  const { date, time } = formatDateParts(details?.date);
  const matchId = match?.id;
  const blanketHref = matchId ? `/kader/matches/${matchId}` : undefined;

  const homeLogo = home.logo || "bayern";
  const awayLogo = away.logo || "newcastle";

  const onBlankett = () => {
    if (!matchId) return;
    handleClose();
    navigate(`/kader/matches/${matchId}`);
  };

  const submenuActions = [
    { key: 'blankett', label: 'Blankett Ausfüllen', icon: 'gear', to: blanketHref, onClick: onBlankett, disabled: !matchId },
    { key: 'cancel', label: 'Spiel Absagen', icon: 'xmark' },
    { key: 'reschedule', label: 'Spiel Verschieben', icon: 'calendar' },
  ];

  return (
    <Spring className="card">
      <div className={styles.header}>
        <h3>Nächstes Spiel</h3>
        <button aria-label="Ticket actions" onClick={handleClick} disabled={loading}>
          <i className="icon icon-gear-regular" />
        </button>
        {/* If your <Submenu> supports onAction, this will trigger the action's onClick.
            If it instead uses the "to" prop for links, we also provided `to`. */}
        <Submenu
          open={open}
          onClose={handleClose}
          anchorEl={anchorEl}
          actions={submenuActions}
          onAction={(action) => action?.onClick?.()}
        />
      </div>

      <div className={styles.teams}>
        <div className={styles.teams_item}>
          <LazyImage className={styles.logo} src={homeLogo} alt={home?.name || 'Heimteam'} />
          <h3 className={styles.teamName}>{loading ? '—' : home?.name || 'Heimteam'}</h3>
        </div>
        <div className={styles.teams_item}>
          <LazyImage className={styles.logo} src={awayLogo} alt={away?.name || 'Auswärtsteam'} />
          <h3 className={styles.teamName}>{loading ? '—' : away?.name || 'Auswärtsteam'}</h3>
        </div>
      </div>

      <div className={styles.details} id="ticket">
        <div className={styles.details_item}>
          <span className="h6 label">Stadium</span>
          <span className="h4">{loading ? '—' : details?.location || details?.stadium || '—'}</span>
        </div>
        <div className={styles.details_item}>
          <span className="h6 label">Datum</span>
          <span className="h4">{loading ? '—' : date}</span>
        </div>
        <div className={styles.details_item}>
          <span className="h6 label">Uhrzeit</span>
          <span className="h4">{loading ? '—' : time}</span>
        </div>
      </div>

      {/* <div className="card-padded text-12" style={{ opacity: 0.7 }}>
        {loading ? '—' : `Gameday ${details?.gameday ?? '—'} • Status: ${status}`}
      </div> */}
    </Spring>
  );
};

export default Ticket;
